import { render } from "./search-preferences.vue?vue&type=template&id=3465965e&scoped=true"
import script from "./search-preferences.js?vue&type=script&lang=js&external"
export * from "./search-preferences.js?vue&type=script&lang=js&external"

import "./search-preferences.css?vue&type=style&index=0&id=3465965e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3465965e"]])

export default __exports__